import React, { FC, MutableRefObject, RefObject, useMemo } from "react"

import {
    setEmail,
    setName,
    setPhone,
    setPhoneError,
    getInputStyle,
} from "modules/Booking/FormPage/common"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { PhoneInput } from "modules/Booking/FormPage/components/PhoneInput"
import { useFormPageContext } from "modules/Booking/FormPage/common/FormPageContext"
import { Input } from "ui-kit/components-branded/FormControls/Input/Input"
import { FormInput } from "modules/Booking/FormPage/components/UserDetailsForm/components/FormInput"

interface Props {
    refPhoneLabel: MutableRefObject<HTMLDivElement | null>
    refEmailLabel: MutableRefObject<HTMLLabelElement | null>
    refNameLabel: MutableRefObject<HTMLLabelElement | null>
    refPhone: RefObject<HTMLInputElement>
    refEmail: RefObject<HTMLInputElement>
    refName: RefObject<HTMLInputElement>
}

export const UserDetailsForm: FC<Props> = ({
    refPhoneLabel,
    refEmailLabel,
    refNameLabel,
    refPhone,
    refEmail,
    refName,
}) => {
    const [{ isVerified }] = useClientContext()
    const [
        {
            form: {
                name,
                email,
                phone,
                emailError,
                nameError,
                showErrors,
                phoneError,
                showEmailError,
            },
        },
        { dispatch },
    ] = useFormPageContext()

    const { phoneInputStyles } = useMemo(() => {
        return {
            phoneInputStyles: getInputStyle(!!phoneError && showErrors),
        }
    }, [emailError, nameError, phoneError, showErrors])

    return (
        <>
            <FormInput
                error={!!phoneError && showErrors ? phoneError : ""}
                label={"Номер телефона"}
                refLabel={refPhoneLabel}
            >
                <PhoneInput
                    name="phone"
                    defaultValue={phone}
                    className={phoneInputStyles}
                    phoneValidationError={(error) => {
                        dispatch(setPhoneError(error))
                    }}
                    setPhoneNumber={(phoneNumber: string) => {
                        dispatch(setPhone(phoneNumber.replace(/ /g, "")))
                    }}
                    ref={refPhone}
                />
            </FormInput>
            <div className="user-details-form__phone-info">
                Пришлем контакты психолога и напомним о&nbsp;сессии.
            </div>
            <Input
                disabled={isVerified}
                error={emailError && (showEmailError || showErrors) ? emailError : ""}
                label="Почта"
                name="email"
                ref={refEmail}
                refLabel={refEmailLabel}
                value={email}
                onChange={(value) => {
                    dispatch(setEmail(value))
                }}
            />
            <Input
                error={showErrors ? nameError : ""}
                isMiddleSpacesAllowed
                label="Имя"
                name="name"
                ref={refName}
                refLabel={refNameLabel}
                value={name}
                onChange={(value) => {
                    dispatch(setName(value))
                }}
            />
        </>
    )
}
